import { useLocation } from 'react-router'

import { matchesPaths } from '@/lib/helpers/routeHelpers'

export function useMatchesPath(paths: string[]) {
  const location = useLocation()

  return matchesPaths(location.pathname, paths)
}
